/* eslint-disable jira/filename-case */
export const FIXED_ITEM = 'fixedItem';
export const FIXED_ITEM_BUTTON = 'fixedItemButton';
export const FIXED_ITEM_ACTION = 'fixedItemAction';
export const CUSTOM_ITEM = 'customItem';
export const CUSTOM_ITEM_BUTTON = 'customItemButton';
export const CUSTOM_ITEM_ACTION = 'customItemAction';
export const CUSTOM_ITEM_DROPDOWN_ACTION = 'customItemDropdownAction';
export const FIXED_ITEM_DROPDOWN_ACTION = 'fixedItemDropdownAction';

export type ComponentType =
	| typeof FIXED_ITEM
	| typeof FIXED_ITEM_BUTTON
	| typeof FIXED_ITEM_ACTION
	| typeof CUSTOM_ITEM
	| typeof CUSTOM_ITEM_BUTTON
	| typeof CUSTOM_ITEM_ACTION
	| typeof CUSTOM_ITEM_DROPDOWN_ACTION
	| typeof FIXED_ITEM_DROPDOWN_ACTION;
